//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscDomain(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 5H20V19H3.89474V8H19.1053M15.5 10.5L10.5 15.5L8 13" fill="none" stroke="currentColor" strokeWidth={2} /></svg>;
}
export default IconMiscDomain;